import {SplitPageLayout} from '@primer/react'
import {Description} from '../components/overview/Description'
import {EarlyDevelopmentBanner} from '../components/overview/EarlyDevelopmentBanner'
import {CopilotReviewSummary} from '../components/overview/CopilotReviewSummary'
import {ChangeSummary} from '../components/overview/ChangeSummary'
import {Findings} from '../components/overview/Findings'
import {OverviewPanel} from '../components/overview/OverviewPanel'
import {StickySidebar} from '@github-ui/sticky-sidebar'
import {MINI_HEADER_HEIGHT} from '../helpers/constants'
import {CollapsiblePanel} from '../components/overview/CollapsiblePanel'
import {useIsDockedPanelCompact, useIsDockedPanelOpen} from '../contexts/DockedPanelContext'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {ActionItemsSection} from '../components/overview/action-items/ActionItemsSection'
import {isPullRequestOpenState} from '../utils/pull-request-state'
import {CommentsSection} from '../components/overview/action-items/CommentsSection'
import {useLayoutRouteData} from '../page-data/loaders/use-layout-route-data'
import {SIDEBAR_WITH_PANEL_BREAKPOINT, useMinWidth} from '../helpers/measure-viewport'
import styles from './Overview.module.css'
import {ForYouSection} from '../components/overview/for-you/ForYouSection'

export function OverviewEntrypoint() {
  return <OverviewComponent />
}

function OverviewComponent() {
  const isDockedPanelOpen = useIsDockedPanelOpen()
  const isCompact = useIsDockedPanelCompact()
  const hasRoomForBoth = useMinWidth(SIDEBAR_WITH_PANEL_BREAKPOINT)
  const showOverviewSidebar = !isDockedPanelOpen || isCompact || hasRoomForBoth
  const isFindingsEnabled = isFeatureEnabled('copilot_code_review_findings_ui')
  const isActionabilityFrameworkEnabled = isFeatureEnabled('prs_overview_actionability_framework')
  const isEarlyDevelopmentBannerEnabled = isFeatureEnabled('overview_early_development_banner')
  const isForYouEnabled = isFeatureEnabled('prs_overview_for_you_section')

  const {pullRequest} = useLayoutRouteData()
  const isPROpen = isPullRequestOpenState(pullRequest.state)

  const showActionItemsSection = isPROpen && !isForYouEnabled
  const showForYouSection = isPROpen && isForYouEnabled

  return (
    <div className={`width-full ${styles.layout}`} data-side-panel-open={isDockedPanelOpen && !isCompact}>
      <SplitPageLayout className={styles.wrapper}>
        <SplitPageLayout.Content as="div" padding="none" className={styles.content}>
          <div className={`d-flex gap-4 flex-column`}>
            {isEarlyDevelopmentBannerEnabled && <EarlyDevelopmentBanner />}
            <CopilotReviewSummary />
            <Description />
            {showActionItemsSection && (
              <CollapsiblePanel heading="Action items">
                {isActionabilityFrameworkEnabled && <CommentsSection />}
                <ActionItemsSection />
              </CollapsiblePanel>
            )}
            {showForYouSection && (
              <CollapsiblePanel heading="For you">
                <ForYouSection />
              </CollapsiblePanel>
            )}
            <ChangeSummary />
            {isFindingsEnabled && <Findings />}
          </div>
        </SplitPageLayout.Content>
        {showOverviewSidebar && (
          <SplitPageLayout.Pane
            aria-label="Pull request overview sidebar"
            position="end"
            divider="none"
            padding="none"
            width="large"
            className={styles.panel}
          >
            <StickySidebar topOffset={MINI_HEADER_HEIGHT}>
              <OverviewPanel />
            </StickySidebar>
          </SplitPageLayout.Pane>
        )}
      </SplitPageLayout>
    </div>
  )
}
